module.exports = __webpack_public_path__ + "static/media/diamond2.65eb25a8.png";